import { render } from "./customInput.vue?vue&type=template&id=6cbf4e4c"
import script from "./customInput.vue?vue&type=script&lang=js"
export * from "./customInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__